export interface UsStateCapitol {
  name: string;
  capitol: {
    name: string;
    lng: number;
    lat: number;
  };
}

export const STATE_CAPITOL_ZOOM = 7;

export const US_STATE_CAPITOLS = {
  AL: { name: 'Alabama', capitol: { name: 'Montgomery', lng: -86.2792, lat: 32.3617 } },
  AK: { name: 'Alaska', capitol: { name: 'Juneau', lng: -134.4197, lat: 58.3019 } },
  AZ: { name: 'Arizona', capitol: { name: 'Phoenix', lng: -112.074, lat: 33.4484 } },
  AR: { name: 'Arkansas', capitol: { name: 'Little Rock', lng: -92.2896, lat: 34.7465 } },
  CA: { name: 'California', capitol: { name: 'Sacramento', lng: -121.4944, lat: 38.5816 } },
  CO: { name: 'Colorado', capitol: { name: 'Denver', lng: -104.9903, lat: 39.7392 } },
  CT: { name: 'Connecticut', capitol: { name: 'Hartford', lng: -72.6734, lat: 41.7658 } },
  DC: { name: 'District of Columbia', capitol: { name: 'Washington', lng: -77.0369, lat: 38.9072 } },
  DE: { name: 'Delaware', capitol: { name: 'Dover', lng: -75.5244, lat: 39.1582 } },
  FL: { name: 'Florida', capitol: { name: 'Tallahassee', lng: -84.2807, lat: 30.4383 } },
  GA: { name: 'Georgia', capitol: { name: 'Atlanta', lng: -84.388, lat: 33.749 } },
  HI: { name: 'Hawaii', capitol: { name: 'Honolulu', lng: -157.8581, lat: 21.3099 } },
  ID: { name: 'Idaho', capitol: { name: 'Boise', lng: -116.2023, lat: 43.615 } },
  IL: { name: 'Illinois', capitol: { name: 'Springfield', lng: -89.6501, lat: 39.7817 } },
  IN: { name: 'Indiana', capitol: { name: 'Indianapolis', lng: -86.1581, lat: 39.7684 } },
  IA: { name: 'Iowa', capitol: { name: 'Des Moines', lng: -93.625, lat: 41.5868 } },
  KS: { name: 'Kansas', capitol: { name: 'Topeka', lng: -95.6752, lat: 39.0473 } },
  KY: { name: 'Kentucky', capitol: { name: 'Frankfort', lng: -84.8733, lat: 38.2009 } },
  LA: { name: 'Louisiana', capitol: { name: 'Baton Rouge', lng: -91.1871, lat: 30.4515 } },
  ME: { name: 'Maine', capitol: { name: 'Augusta', lng: -69.7795, lat: 44.3106 } },
  MD: { name: 'Maryland', capitol: { name: 'Annapolis', lng: -76.4922, lat: 38.9784 } },
  MA: { name: 'Massachusetts', capitol: { name: 'Boston', lng: -71.0589, lat: 42.3601 } },
  MI: { name: 'Michigan', capitol: { name: 'Lansing', lng: -84.5555, lat: 42.7325 } },
  MN: { name: 'Minnesota', capitol: { name: 'Saint Paul', lng: -93.09, lat: 44.9537 } },
  MS: { name: 'Mississippi', capitol: { name: 'Jackson', lng: -90.1848, lat: 32.2988 } },
  MO: { name: 'Missouri', capitol: { name: 'Jefferson City', lng: -92.1735, lat: 38.5767 } },
  MT: { name: 'Montana', capitol: { name: 'Helena', lng: -112.0391, lat: 46.5891 } },
  NE: { name: 'Nebraska', capitol: { name: 'Lincoln', lng: -96.7026, lat: 40.8136 } },
  NV: { name: 'Nevada', capitol: { name: 'Carson City', lng: -119.7674, lat: 39.1638 } },
  NH: { name: 'New Hampshire', capitol: { name: 'Concord', lng: -71.5376, lat: 43.2081 } },
  NJ: { name: 'New Jersey', capitol: { name: 'Trenton', lng: -74.7597, lat: 40.2206 } },
  NM: { name: 'New Mexico', capitol: { name: 'Santa Fe', lng: -105.9378, lat: 35.687 } },
  NY: { name: 'New York', capitol: { name: 'Albany', lng: -73.7562, lat: 42.6526 } },
  NC: { name: 'North Carolina', capitol: { name: 'Raleigh', lng: -78.6382, lat: 35.7796 } },
  ND: { name: 'North Dakota', capitol: { name: 'Bismarck', lng: -100.7837, lat: 46.8083 } },
  OH: { name: 'Ohio', capitol: { name: 'Columbus', lng: -82.9988, lat: 39.9612 } },
  OK: { name: 'Oklahoma', capitol: { name: 'Oklahoma City', lng: -97.5164, lat: 35.4676 } },
  OR: { name: 'Oregon', capitol: { name: 'Salem', lng: -123.0351, lat: 44.9429 } },
  PA: { name: 'Pennsylvania', capitol: { name: 'Harrisburg', lng: -76.8867, lat: 40.2732 } },
  RI: { name: 'Rhode Island', capitol: { name: 'Providence', lng: -71.4128, lat: 41.824 } },
  SC: { name: 'South Carolina', capitol: { name: 'Columbia', lng: -81.0348, lat: 34.0007 } },
  SD: { name: 'South Dakota', capitol: { name: 'Pierre', lng: -100.351, lat: 44.3683 } },
  TN: { name: 'Tennessee', capitol: { name: 'Nashville', lng: -86.7816, lat: 36.1627 } },
  TX: { name: 'Texas', capitol: { name: 'Austin', lng: -97.7431, lat: 30.2672 } },
  UT: { name: 'Utah', capitol: { name: 'Salt Lake City', lng: -111.891, lat: 40.7608 } },
  VT: { name: 'Vermont', capitol: { name: 'Montpelier', lng: -72.5754, lat: 44.2601 } },
  VA: { name: 'Virginia', capitol: { name: 'Richmond', lng: -77.436, lat: 37.5407 } },
  WA: { name: 'Washington', capitol: { name: 'Olympia', lng: -122.9007, lat: 47.0379 } },
  WV: { name: 'West Virginia', capitol: { name: 'Charleston', lng: -81.6326, lat: 38.3498 } },
  WI: { name: 'Wisconsin', capitol: { name: 'Madison', lng: -89.4012, lat: 43.0731 } },
  WY: { name: 'Wyoming', capitol: { name: 'Cheyenne', lng: -104.8202, lat: 41.14 } },
} as const satisfies Record<string, UsStateCapitol>;

export type UsStateCode = keyof typeof US_STATE_CAPITOLS;

export interface StateCapitolViewport {
  center: [number, number];
  zoom: number;
}

export function getStateCapitolViewport(code: string | null | undefined): StateCapitolViewport | null {
  if (typeof code !== 'string') return null;
  const normalized = code.trim().toUpperCase();
  if (!normalized) return null;
  const entry = (US_STATE_CAPITOLS as Record<string, UsStateCapitol>)[normalized];
  if (!entry) return null;
  return {
    center: [entry.capitol.lng, entry.capitol.lat],
    zoom: STATE_CAPITOL_ZOOM,
  };
}
